/* Project Import will be here */
import { getProductDiscountListApi } from "services/promotions";
import { getErrorObject } from "../utilities/utils";
/* Project Import will be here */

export const types = {
    DISCOUNT_LIST_REQUEST: "discount/RequestDiscountList",
    DISCOUNT_SUCCESS: "discount/DiscountSuccess",
    DISCOUNT_FAILURE: "discount/DiscountFailure",
    SHOW_OR_HIDE_DISCOUNT_DETAILS: "promotion/ShowOrHideDiscountDetails",
};

let initialState = {
    isLoading: false,
    discountList: [],
    count: 0,
    error: null,
    isShowDiscountDetailsModal: false,
};

export const discounts = (state = initialState, action) => {
    switch (action.type) {
        case types.DISCOUNT_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                count: 0,
                discountList: [],
            };
        case types.DISCOUNT_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                error: null
            };
        case types.DISCOUNT_FAILURE:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                error: null
            };
        case types.SHOW_OR_HIDE_DISCOUNT_DETAILS:
            return { ...state, ...action.payload, error: null };
        default:
            return state;
    }
};

/* Get discount list mapped to the selected product */
export const getProductDiscounts = (productId) => {
    return async (dispatch, getState) => {
        await dispatch({ type: types.DISCOUNT_LIST_REQUEST });

        try {
            const reqObj = {
                Page: 0,
                Ids: [productId],
                FilterLevelCode: "",
                NeedFOC: false
            };
            const response = await getProductDiscountListApi(reqObj);
            dispatch({
                type: types.DISCOUNT_SUCCESS,
                payload: {
                    discountList: response.data.Data,
                    count: response.data.Data.length,
                }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.DISCOUNT_FAILURE,
                payload: { error: message, discountList: [] }
            });
        }
    };
};

export const openOrCloseDiscountDetailsModal = (isShow) => {
    return async dispatch => {
        dispatch({
            type: types.SHOW_OR_HIDE_DISCOUNT_DETAILS,
            payload: { isShowDiscountDetailsModal: isShow }
        });
    };
};